import * as Yup from "yup";

export function initialValues(site) {
  return {
    name:    site?.name    || "",
    cuit:    site?.cuit    || "",
    address: site?.address || "",
    phone:   site?.phone   || "",
    email:   site?.email   || "",
    country: site?.country || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El campo es requerido"),
    cuit: Yup.string().required("El campo es requerido"),
    address: Yup.string().required("El campo es requerido"),
    phone: Yup.string().required("El campo es requerido"),
    email: Yup.string().email("Ingrese un Correo Electrónico válido").required("El campo es requerido"),
  });
}
